module.exports = __webpack_public_path__ + "static/media/cross-icon.f590bb03.svg";